import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountTypeService {

  constructor(private dataService: DataService) { }

    getAccountTypes(): Observable<any> {
      return this.dataService.getAccountTypes();
    }

    getAccountType(id: number): Observable<any> {
      return this.dataService.getAccountType(id);
    }
  
}
